var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isHome)?_c('nav-bar'):_vm._e(),_c('keep-alive',[_c('router-view')],1),_c('scroll-to-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }